import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoFaqWithImg from 'eco-design/sections/eco-faq-win-img';
import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
export default function Comp() {
    const { t } = useLang('theProduct');
    const { locale = 'us' } = getLocal();

    const IS_JP_SITE = ['jp'].includes(locale);

    const itemsA = [
        {
            pc: IS_JP_SITE ? 'https://websiteoss.ecoflow.com/upload/image/1745285814902/2.jpg' : 'https://websiteoss.ecoflow.com/upload/image/1744350664068/faq1.jpg',
            title: t('I_item1_title'),
            desc: t('I_item1_desc'),
        },
        {
            pc: IS_JP_SITE ? 'https://websiteoss.ecoflow.com/upload/image/1745285815269/4.jpg' : 'https://websiteoss.ecoflow.com/upload/image/1744350664257/faq2.jpg',
            title: t('I_item2_title'),
            desc: t('I_item2_desc'),
        },
        {
            pc: IS_JP_SITE ? 'https://websiteoss.ecoflow.com/upload/image/1745285815451/5.jpg' : 'https://websiteoss.ecoflow.com/upload/image/1744350707771/faq3.jpg',
            title: t('I_item3_title'),
            desc: t('I_item3_desc'),
        },
        {
            pc: IS_JP_SITE ? 'https://websiteoss.ecoflow.com/upload/image/1745285815631/6.jpg' : 'https://websiteoss.ecoflow.com/upload/image/1744350707943/faq4.jpg',
            title: t('I_item4_title'),
            desc: t('I_item4_desc'),
        },
    ];

    return (
        <div className={styles.comp} id="FaqA">
            <EcoSpace />
            <EcoSectionCommon label={t('I_label')} title={t('I_title')} desc={t('I_desc')} />
            <EcoSpaceSmall />
            <EcoFaqWithImg items={itemsA} />
            {locale === 'jp' && <EcoSpace />}
        </div>
    );
}
